import React from 'react';

interface InnerCircleProps {
  size: number;
  radius: number;
  month: string;
  total: string;
}

const InnerCircle: React.FC<InnerCircleProps> = ({
  size,
  radius,
  month,
  total
}) => {
  const circlePosition = size / 2;
  return (
    <g transform={`translate(${circlePosition} ${circlePosition})`}>
      <circle
        cx="0"
        cy="0"
        r={radius}
        fill="#fff"
        style={{
          filter: 'drop-shadow(3px 4px 8px rgba(107, 107, 107, 0.2))'
        }}
      ></circle>
      <text
        id="donut-inner-circle-month"
        x="0"
        y="-6"
        alignmentBaseline="middle"
        fontSize="5"
        strokeWidth="0"
        stroke="#000"
        textAnchor="middle"
      >
        {month}
      </text>
      <text
        id="donut-inner-circle-total"
        x="0"
        y="4"
        alignmentBaseline="middle"
        fontSize="8.5"
        fontWeight="bold"
        strokeWidth="0"
        stroke="#000"
        textAnchor="middle"
      >
        {total}
      </text>
    </g>
  );
};

export default InnerCircle;
